const newsletterAnalytics = () => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];

	window.dataLayer.push({ values: null });
	window.dataLayer.push({
		event: 'CompleteRegistration',
		values: {
			content_name: 'newsletter',
		},
	});

	window.dataLayer.push({
		event: 'sign_up',
		method: 'newsletter',
	});
};

export default newsletterAnalytics;
